import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private _http: HttpClient
  ) { }

  login(user: User): Observable<any> {
    return this._http.post('api/token/', user);
  }

  refreshToken(token: any): Observable<any> {
    return this._http.post('api/token/refresh/', { refresh: token });
  }

  logout(refreshToken: any): Observable<any> {
    return this._http.post('auth/logout/',
      { refresh: refreshToken })
  }
  getUserDetail(inviteCode:any) : Observable<any>{
    const headers = new HttpHeaders({
      'token': inviteCode
    });
    return this._http.get('user/info/', {headers: headers})
  }
  forgotPassword(email:any ): Observable<any> {
    return this._http.post('user/forgot-password/', {email:email})
  }
  setPassword(password:any, inviteKey:any): Observable<any>{
    const headers = new HttpHeaders({
      'token': inviteKey
    });
    return this._http.put('user/set-new-password/',password ,{headers:headers})
  }
  validateUserInvite(inviteKey:string){
    return this._http.get('user/check-token-validity/' + inviteKey  )
  }
}
